import { render, staticRenderFns } from "./SetAddNewAmountAuthorPopup.vue?vue&type=template&id=473cd80c&"
import script from "./SetAddNewAmountAuthorPopup.vue?vue&type=script&lang=js&"
export * from "./SetAddNewAmountAuthorPopup.vue?vue&type=script&lang=js&"
import style0 from "./SetAddNewAmountAuthorPopup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports